export const REPORT_SECTIONS = {
  DIGITAL_TWIN: "digitalTwin",
  CHECK: "check",
  ALIGN: "align",
  ANNEX: "annex",
};

export const REPORT_SECTION_LIST = Object.values(REPORT_SECTIONS);

export const DEFAULT_REPORT_SECTION = REPORT_SECTIONS.ANNEX;
